/**
 * The old Buyers and Suppliers addresses, kept working.
 *
 * Buyers and suppliers are companies with the data buyer and data seller
 * roles now, so `/buyers` opens Companies filtered to data buyers, and a
 * bookmarked `/buyers/:id` opens that buyer's company on its "Buys from us"
 * tab (`/suppliers` likewise, on "Sells to us"). The buyer and supplier ids
 * are unchanged; only the page that shows them moved.
 */
import { Group, Loader } from '@mantine/core';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useEntities, type EntityKind } from '../../api/queries';

const ROLE: Record<EntityKind, { role: string; tab: string }> = {
  buyers: { role: 'data_buyer', tab: 'buys' },
  suppliers: { role: 'data_seller', tab: 'sells' },
};

/** `/buyers` and `/suppliers`: the filtered company list, keeping any query. */
export function RoleListRedirect({ kind }: { kind: EntityKind }) {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  params.set('role', ROLE[kind].role);
  return <Navigate to={`/companies?${params.toString()}`} replace />;
}

/** `/buyers/:id` and `/suppliers/:id`: the record's company, on its role's tab. */
export function RoleRecordRedirect({ kind }: { kind: EntityKind }) {
  const { id = '' } = useParams();
  const list = useEntities(kind);
  if (list.isPending) return <Group justify="center" p="xl"><Loader /></Group>;
  const company = list.data?.entities.find((e) => e.id === id)?.company_id;
  if (!company) return <Navigate to={`/companies?role=${ROLE[kind].role}`} replace />;
  return <Navigate to={`/companies/${company}?tab=${ROLE[kind].tab}`} replace />;
}
